// extracted by mini-css-extract-plugin
module.exports = {"language-switcher":"LanguageSwitcher_language-switcher__a_lNu","is-active":"LanguageSwitcher_is-active__BBK7L"};